'use client';

import Link from 'next/link';

import type {
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { Logo } from '@eliadmin/core/src/components/ui/logo';
import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { getSafeHref } from '@eliadmin/core/src/utils/url-utils';
import { usePathname } from 'next/navigation';
import MobileSidebar from '@eliadmin/core/src/components/header/mobile-sidebar';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function HeaderClient({
  generalLayout,
  menu,
}: {
  generalLayout: GeneralLayout['data'];
  menu: Menu;
}) {
  const { t } = useTranslations();
  const pathname = usePathname();

  const isHomepage = pathname === ROUTES.HOME();

  const logoUrl = isHomepage ? generalLayout?.header?.logo?.url : generalLayout?.footer?.logo?.url;

  return (
    <header
      className={cn(
        'custom-section',
        'py-3 sm:py-4 lg:py-[18px]',
        isHomepage && 'absolute left-0 top-0 z-30',
      )}
    >
      <div className={cn('custom-container', 'hidden items-center justify-between md:flex')}>
        <div className="flex flex-1 items-center justify-start">
          <Logo
            className={{ image: 'h-10 sm:h-12 lg:h-14 xl:h-16' }}
            generalLayout={generalLayout}
            src={logoUrl}
          />
        </div>
        <div className="flex items-center justify-center gap-6 lg:gap-8">
          {menu.fields.map(field => (
            <Link
              key={field.name}
              href={getSafeHref(field?.path ?? '#')}
              className={cn(
                'text-sm font-bold xl:text-base',
                isHomepage ? 'text-white' : 'text-secondary',
              )}
            >
              {field.name}
            </Link>
          ))}
        </div>
        <div className="flex flex-1 items-center justify-end">
          <Button asChild>
            <Link href={'/rezervacia'}>{t('text1335')}</Link>
          </Button>
        </div>
      </div>
      <div className="flex w-full items-center justify-between md:hidden">
        <div className="flex items-center justify-start gap-3">
          <div className="flex h-10 w-10 items-center justify-center">
            <MobileSidebar isHomepage={isHomepage} menu={menu.fields} />
          </div>
          <Logo className={{ image: 'h-10 sm:h-12' }} generalLayout={generalLayout} src={logoUrl} />
        </div>
        <Button asChild className="h-10">
          <Link href={'/rezervacia'}>{t('text1335')}</Link>
        </Button>
      </div>
    </header>
  );
}
